import DataModel from '../../library/proto/data-model'

/**
 * @param {Number} id 該Model的辨識索引
 * @param {String} title 標題字
 * @param {String} image 圖片位址
 * @param {String} image_title 圖片說明文字
 * @param {String} image_alt 圖片替代文字
 * @param {String} updated_user 更新使用者
*/
export default class SystemImagesModel extends DataModel {
  constructor (args) {
    super(args)
    const entity = args || {}
    this.id = entity.id || 0
    this.title = entity.title || ''
    this.image = entity.image || ''
    this.image_title = entity.image_title || ''
    this.image_alt = entity.image_alt || ''
    this.updated_user = entity.updated_user || ''
  }
}
